import React, { useState, useEffect } from 'react';
import { Toaster } from './components/ui/sonner';
import Navigation from './components/Navigation';
import HeroSection from './components/HeroSection';
import ServicesSection from './components/ServicesSection';
import GallerySection from './components/GallerySection';
import VideoSection from './components/VideoSection';
import ReviewsSection from './components/ReviewsSection';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';
import WhatsAppButton from './components/WhatsAppButton';
import AdminPanel from './components/AdminPanel';
import { translations } from './data/mock';
import './App.css';

function App() {
  const [currentLang, setCurrentLang] = useState('ro');
  const [showAdmin, setShowAdmin] = useState(false);
  const t = translations[currentLang];

  // Detect browser language on initial load
  // Romanian is default, user can switch to English
  useEffect(() => {
    // Keep Romanian as default - no auto-detection
    // Users can manually switch to English if needed
  }, []);

  // Check for admin route
  useEffect(() => {
    const checkAdminRoute = () => {
      if (window.location.pathname === '/admin' || window.location.hash === '#admin') {
        setShowAdmin(true);
      }
    };
    
    checkAdminRoute();
    window.addEventListener('hashchange', checkAdminRoute);
    return () => window.removeEventListener('hashchange', checkAdminRoute);
  }, []);

  const handleLanguageChange = (lang) => {
    setCurrentLang(lang);
  };

  // Show admin panel
  if (showAdmin) {
    return (
      <>
        <Toaster position="top-right" />
        <AdminPanel onBack={() => {
          setShowAdmin(false);
          window.history.pushState({}, '', '/');
        }} />
      </>
    );
  }

  return (
    <div className="App">
      <Toaster position="top-right" />
      <Navigation
        t={t}
        currentLang={currentLang}
        onLanguageChange={handleLanguageChange}
      />
      <HeroSection t={t} currentLang={currentLang} />
      <ServicesSection t={t} currentLang={currentLang} />
      <GallerySection t={t} />
      <VideoSection t={t} />
      <ReviewsSection t={t} />
      <ContactSection t={t} />
      <Footer t={t} currentLang={currentLang} />
      <WhatsAppButton currentLang={currentLang} />
    </div>
  );
}

export default App;
